import Link from 'next/link';
import { MouseEvent, ReactNode } from 'react';
import { sendMessageToMobile } from '@utils/mobile';
import { isMobileApp } from '@utils/environment';

interface ILinkToProduct {
  handle: string;
  submitInsights?: () => unknown;
  trackingId?: string;
  children: ReactNode;
}

export const LinkToProduct = ({
  handle,
  trackingId,
  submitInsights,
  children,
}: ILinkToProduct) => {
  const onClickItem = (e: MouseEvent<HTMLAnchorElement>) => {
    submitInsights?.();
    if (isMobileApp) {
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
      sendMessageToMobile('goToProduct', { handle });
    }
  };

  return (
    <Link
      href={`/products/${handle}${
        trackingId ? `?trackingId=${trackingId}` : ''
      }`}
      onClick={onClickItem}
      data-testid="ProductImage-go-to-product-page"
    >
      {children}
    </Link>
  );
};
